import './ProfileTools.scss';

import { useDispatch } from "react-redux";

import { openModal } from "../../../slices/modalSlice";

import Key from "@mui/icons-material/Key";

import PasswordModal from "../../../password-modal/PasswordModal";

import { TextButton } from "../../../common-components/Buttons/Buttons";

const ProfileTools = () => {
    const dispatch = useDispatch();

    const handleOpen = () => {
        dispatch(openModal({closeable: true, content: <PasswordModal/>}));
    }

    return (
        <div className={"profile-tools"}>
            <div className={"profile-tools_container"}>
                <TextButton Icon={Key} title={"Сменить пароль"} onClick={handleOpen} color={"#ffeb3b"} active={true}/>
            </div>
        </div>
    )
}

export default ProfileTools;